import React, { useState, useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";

// Components
import PageLoading from "sharedComponents/Loading/PageLoading";
import { Col } from "antd";
import SpecificSurvey from "./components/SpecificSurvey";
// Models
import {externalSurvey} from "models/externalSurvey";

// Styles
import './style/external_survey.scss';

const ExternalSurveys = ({
    UUID = null,
}) => {
    const [survey, SetSurvey] = useState(null);
    const [loading, SetLoading] = useState(false);

    const pageTitle = useMemo(() => (
        survey?.title?.trim() || 'PMS'
    ), [survey?.title]);

    const pageDescription = useMemo(() => {
        if (!survey?.description) {
            return 'Performance Management Platform (PMS)';
        }

        // Strip any HTML tags that might be embedded in the survey description.
        const textOnly = survey.description.replace(/<[^>]*>/g, ' ');

        return textOnly.replace(/\s+/g, ' ').trim() || 'Performance Management Platform (PMS)';
    }, [survey?.description]);

    const getSurvey = async () => {
        SetLoading(true);

        try {
            const response = await externalSurvey.getExternalSurvey(UUID);

            if (!response?.data?.success) {
                throw new Error('Something went wrong');
            }

            SetSurvey(response.data.survey);
            SetLoading(false);
        } catch (e) {
            console.log(e);
            throw new Error('Something went wrong');
        }
    };

    useEffect(() => {
        getSurvey();
        // eslint-disable-next-line
    }, [UUID]);

    return(
        <div className='gusto_page_container'>
            <div className='modal_container modal'>
                <Helmet>
                    <title>{pageTitle}</title>
                    <meta name="description" content={pageDescription} />
                    <meta property="og:title" content={pageTitle} />
                    <meta property="og:description" content={pageDescription} />
                    <meta name="twitter:title" content={pageTitle} />
                    <meta name="twitter:description" content={pageDescription} />
                </Helmet>
                {
                    !survey || loading ? (
                        <PageLoading />
                    ) : (
                        <Col className="survey" span={24}>
                            <SpecificSurvey selectedSurvey={survey} />
                        </Col>
                    )
                }
            </div>
        </div>
    )
}
export default ExternalSurveys
